import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import Clientclasses from "../../assets/css/ClientForm.module.css";
import classes from "../../assets/css/CustomerDetails.module.css";
import NotificationAlert from "react-notification-alert";
import { Dialog, DialogContent, MenuItem, Select } from "@mui/material";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardTitle,
  Col,
  Form,
  FormGroup,
  Input,
  Row,
} from "reactstrap";
import { useFormik } from "formik";
import { useHistory } from "react-router-dom";
import MaskedInput from "react-text-mask";
import ReferenceDataContext from "AvatarContext";
import { AxiosAPiGet } from "AxiosAPi";
import { CustomerFormSchema } from "utils/schemas/CustomerFormSchema";
import { AxiosAPiPost } from "AxiosAPi";
function CustomerForm({ open, setOpen, fetchCustomersList }) {
  const history = useHistory();
  const notificationAlertRef = useRef(null);
  const { rolePermissions } = useContext(ReferenceDataContext);
  const [clientList, setClientList] = useState([]);
  const [clientName, setClientName] = useState("");
  const [clientNameWithId, setClientNameWithId] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(false);
  const { clientId } = JSON.parse(localStorage.getItem("userData")).data;
  let client_list = !rolePermissions?.includes("clientList") ? "client" : "";
  const initialValues = {
    clientId: !rolePermissions?.includes("clientList") ? clientId : "",
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    isActive: "Active",
  };
  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues,
    validationSchema: CustomerFormSchema,
    onSubmit: (values, action) => {
      const data = {
        clientId: values.clientId,
        firstName: values.first_name,
        lastName: values.last_name,
        email: values.email,
        phone: values.phone,
        isActive: values.isActive,
      };
      setLoading(true);
      AxiosAPiPost(
        `${process.env.REACT_APP_AXIOS_BASE_URL}/customers/save`,
        "post",
        data,
        (response) => {
          if (response.data.status === true) {
            onAlertShow(response.data.message, "success");
            action.resetForm();
            setTimeout(() => {
              fetchCustomersList();
              handleClose();
              setLoading(false);
            }, 2000);
          } else {
            onAlertShow(response.data.message, "warning");
            setLoading(false);
          }
        },
        history,
        (err) => {
          if (err.response.data.status === false) {
            setLoading(false);
            if (err.response.status === 422) {
              if (err.response.data.errors.clientId) {
                onAlertShow(
                  err.response.data.errors.clientId.message,
                  "warning"
                );
              }
              if (err.response.data.errors.email) {
                onAlertShow(err.response.data.errors.email.message, "warning");
              }
            } else {
              onAlertShow(err.response.data.message, "warning");
            }
          }
        }
      );
    },
  });
  const fetchClientDetails = useCallback(
    (url) => {
      AxiosAPiGet(
        url,
        "get",
        (res) => {
          setClientList(
            res.data?.data?.map((name) => {
              let clientData;
              clientData = name?.hasOwnProperty("company_name")
                ? name?.company_name === "" ||
                  name?.company_name === undefined ||
                  name?.company_name === null
                  ? name?.name === "" ||
                    name?.name === undefined ||
                    name?.name === null
                    ? {
                        ...name,
                        client_id: `${name?.clientId}`,
                        clientName: `${name?.first_name} ${name?.last_name}`,
                        clientName_with_id: `${name?.first_name} ${name?.last_name} (${name?.clientId})`,
                      }
                    : {
                        ...name,
                        client_id: `${name?.clientId}`,
                        clientName: `${name?.name}`,
                        clientName_with_id: `${name?.name} (${name?.clientId})`,
                      }
                  : {
                      ...name,
                      client_id: `${name?.clientId}`,
                      clientName: `${name.company_name}`,
                      clientName_with_id: `${name.company_name} (${name?.clientId})`,
                    }
                : name?.name === "" ||
                  name?.name === undefined ||
                  name?.name === null
                ? {
                    ...name,
                    client_id: `${name?.clientId}`,
                    clientName: `${name?.first_name} ${name?.last_name}`,
                    clientName_with_id: `${name?.first_name} ${name?.last_name} (${name?.clientId})`,
                  }
                : {
                    ...name,
                    client_id: `${name?.clientId}`,
                    clientName: `${name?.name}`,
                    clientName_with_id: `${name?.name} (${name?.clientId})`,
                  };
              return { clientData };
            })
          );
        },
        history,
        (err) => {
          onAlertShow(err.response.data.message, "warning");
          // setLoadingCustomerDetails(false);
        }
      );
    },
    [history]
  );
  useEffect(() => {
    let url = "";
    switch (client_list) {
      case "":
        url = `${process.env.REACT_APP_AXIOS_BASE_URL}/clients/all?status=Active`;
        fetchClientDetails(url);
        break;

      default:
        break;
    }
  }, [client_list, fetchClientDetails]);
  function handleClose() {
    setOpen(false);
  }
  const onAlertShow = (message, type) => {
    let options = {};
    options = {
      place: "tr",
      message: message,
      type: type,
      icon: "tim-icons icon-bell-55",
      autoDismiss: 3,
    };
    notificationAlertRef.current.notificationAlert(options);
  };
  const handleClientList = (k, client) => {
    setClientName(client.clientName);
    setClientNameWithId(client.clientName_with_id);
    setFieldValue("clientId", client.clientId);
    setSearchValue("");
    // setOpenDropdown(false)
  };
  const handleClientNameRemove = () => {
    setClientName("");
    setFieldValue("clientId", "");
    setClientNameWithId("");
  };
  const handleKeyEvent = (e) => {
    e.preventDefault();
  };
  // const handleSpecialCharacters = (e) => {
  //   var keycode = e.which || e.keyCode;

  //   if (
  //     (keycode > 8 && keycode < 48 && keycode !== 32) ||
  //     (keycode > 57 && keycode < 65) ||
  //     (keycode > 90 && keycode < 97) ||
  //     keycode > 122
  //   ) {
  //     e.preventDefault();
  //   }
  // };
  return (
    <div
      className={Clientclasses["client_form_content"]}
      onClick={() => {
        if (openDropdown) setOpenDropdown(false);
        return;
      }}
    >
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            backgroundColor: "#fadf9e",
          },
        }}
      >
        <div className="rna-container">
          <NotificationAlert ref={notificationAlertRef} />
        </div>

        <DialogContent dividers className="px-0 px-sm-3 px-md-4">
          <div
            className={`popupForm-holder ${Clientclasses["dialog_content"]}`}
          >
            <Row>
              <Col md="12">
                <Form
                  id="RegisterValidation"
                  onSubmit={handleSubmit}
                  className="commonForm popupForm"
                >
                  <Card className="customColor6">
                    <CardHeader>
                      <CardTitle
                        className={`accordionHeaderColor labelText mb-0 ${Clientclasses["view_icon_cross"]}`}
                        tag="h4"
                      >
                        Add Customer Form
                        <i
                          onClick={handleClose}
                          className={`fa-solid fa-xmark ${Clientclasses["cursor_style"]}`}
                        ></i>
                      </CardTitle>
                    </CardHeader>
                    <CardBody>
                      {rolePermissions?.includes("clientList") && (
                        <FormGroup className="has-label">
                          <label className="darkText">
                            Client ID <span className="text-danger">*</span>
                          </label>
                          <>
                            <div className={classes["input_container"]}>
                              <Input
                                type="text"
                                id="client_name_input"
                                className={`${classes["client_name_style"]} bg-white`}
                                name="clientId"
                                autoComplete="off"
                                placeholder={
                                  clientName === "" ? "Search Client Name" : ""
                                }
                                onClick={() => setOpenDropdown(!openDropdown)}
                                // onChange={(e) => setClientName(e.target.value)}
                                onKeyDown={(e) => handleKeyEvent(e)}
                                // value={clientName}
                              />
                              {errors.clientId && touched.clientId ? (
                                <p className={Clientclasses["form_error"]}>
                                  {errors.clientId}
                                </p>
                              ) : null}
                              {clientName !== "" && (
                                <button
                                  className={classes["main_button_div"]}
                                  onClick={(e) => e.preventDefault()}
                                >
                                  <p className={classes["client_name_cross"]}>
                                    {clientName} ({values.clientId})
                                  </p>
                                  <p
                                    onClick={handleClientNameRemove}
                                    className={classes["input_cross_container"]}
                                  >
                                    <i className="fa-solid fa-xmark"></i>
                                  </p>
                                </button>
                              )}
                            </div>
                            <div
                              className={
                                openDropdown
                                  ? `${classes["client_name_list_div"]} ${classes["client_name_list_show"]}`
                                  : `${classes["client_name_list_hide"]}`
                              }
                            >
                              {/* <Input
                                className={`bg-white ${classes["search_input_style"]}`}
                                id="client_name_search"
                                type="search"
                                placeholder="Enter your search"
                                value={searchValue}
                                pattern="^\w\s\(\d\)$"
                                onChange={(e) => setSearchValue(e.target.value)}
                                onClick={() => setOpenDropdown(true)}
                                onKeyDown={(e) => handleSpecialCharacters(e)}
                              /> */}
                              {clientList?.length !== 0 ? (
                                clientList
                                  ?.filter((data) =>
                                    data?.clientData?.clientName_with_id
                                      ?.toLowerCase()
                                      ?.includes(searchValue?.toLowerCase())
                                  )
                                  ?.map(
                                    (client, k) =>
                                      client.clientData?.clientId && (
                                        <p
                                          onClick={() =>
                                            handleClientList(
                                              k,
                                              client?.clientData
                                            )
                                          }
                                          key={k}
                                          className={
                                            clientNameWithId ===
                                            client.clientData
                                              ?.clientName_with_id
                                              ? `${classes["client_name_selected"]} ${classes["client_name_list"]}`
                                              : `${classes["client_name_not_selected"]} ${classes["client_name_list"]}`
                                          }
                                          id={`client_name${k}`}
                                        >
                                          {
                                            client?.clientData
                                              ?.clientName_with_id
                                          }
                                        </p>
                                      )
                                  )
                              ) : (
                                <p className={classes["no_records_style"]}>
                                  No records found
                                </p>
                              )}
                            </div>
                          </>
                        </FormGroup>
                      )}

                      <FormGroup className={`has-label`}>
                        <label className="darkText">
                          First Name <span className="text-danger">*</span>
                        </label>
                        <Input
                          name="first_name"
                          placeholder="Enter your first name"
                          type="text"
                          className="bg-white"
                          value={values.first_name}
                          onChange={handleChange}
                        />
                        {errors.first_name && touched.first_name ? (
                          <p className={Clientclasses["form_error"]}>
                            {errors.first_name}
                          </p>
                        ) : null}
                      </FormGroup>
                      <FormGroup className={`has-label`}>
                        <label className="darkText">
                          Last Name <span className="text-danger">*</span>
                        </label>
                        <Input
                          name="last_name"
                          placeholder="Enter your last name"
                          type="text"
                          className="bg-white"
                          value={values.last_name}
                          onChange={handleChange}
                        />
                        {errors.last_name && touched.last_name ? (
                          <p className={Clientclasses["form_error"]}>
                            {errors.last_name}
                          </p>
                        ) : null}
                      </FormGroup>
                      <FormGroup className={`has-label`}>
                        <label className="darkText">
                          Email Address <span className="text-danger">*</span>
                        </label>
                        <Input
                          name="email"
                          placeholder="Enter your email address"
                          type="email"
                          className="bg-white"
                          value={values.email}
                          onChange={handleChange}
                        />
                        {errors.email && touched.email ? (
                          <p className={Clientclasses["form_error"]}>
                            {errors.email}
                          </p>
                        ) : null}
                      </FormGroup>
                      <FormGroup className={`has-label`}>
                        <label className="darkText">
                          Phone Number <span className="text-danger">*</span>
                        </label>
                        <MaskedInput
                          mask={[
                            "(",
                            /[1-9]/,
                            /\d/,
                            /\d/,
                            ")",
                            " ",
                            /\d/,
                            /\d/,
                            /\d/,
                            "-",
                            /\d/,
                            /\d/,
                            /\d/,
                            /\d/,
                          ]}
                          className="form-control bg-white"
                          placeholder="Enter a phone number"
                          name="phone"
                          guide={true}
                          id="my-input-id"
                          value={values.phone}
                          onChange={(e) => {
                            setFieldValue(
                              "phone",
                              e.target.value.replace(/[^A-Z0-9]/gi, "")
                            );
                          }}
                          onBlur={handleBlur}
                        />

                        {errors.phone && touched.phone ? (
                          <p className={Clientclasses["form_error"]}>
                            {errors.phone}
                          </p>
                        ) : null}
                      </FormGroup>

                      <FormGroup className={`has-label`}>
                        <label className="darkText">
                        Subscription Status <span className="text-danger">*</span>
                        </label>
                        <Select
                          name="isActive"
                          className={`w-100 bg-white ${Clientclasses["status_dropdown"]}`}
                          value={values.isActive}
                          onChange={handleChange}
                          displayEmpty
                        >
                          <MenuItem value="">Choose your Status</MenuItem>
                          <MenuItem value="Active">Active</MenuItem>
                          <MenuItem value="Inactive">Inactive</MenuItem>
                        </Select>
                        {errors.isActive && touched.isActive ? (
                          <p className={Clientclasses["form_error"]}>
                            {errors.isActive}
                          </p>
                        ) : null}
                      </FormGroup>
                    </CardBody>
                    <CardFooter className="text-center btn-set">
                      <Button color="info" type="submit">
                        {loading ? "Processing..." : "Add Customer"}
                      </Button>
                    </CardFooter>
                  </Card>
                </Form>
              </Col>
            </Row>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default CustomerForm;
